export const DEFAULT_CURRENCY_PREFIX = '$';

export const DEFAULT_CURRENCY_GROUP_LENGTH = 3;

export const DEFAULT_CURRENCY_FORMAT_OPTIONS = {
  currencyGroupSeparator: ' ',
  currencyDecimalSeparator: '.',
  currency: '$',
};
